export const SingleArticle = (function () {
    "use strict";

    let $articleImageBlock;

    function init() {
      $articleImageBlock = $('.article-layout .wp-block-image');

			if ($articleImageBlock) {
				addBackgroundImages();
			}
    }

		function addBackgroundImages(){
			$articleImageBlock.each(function(){
				let $image = $(this).find('img');

				if ($image.length > -1) {
					let $imageClone = $($image.parent().html());
					const $imageWrapper = $('<div class="featured-image__bg" aria-hidden="true">')
					$imageClone.prop('alt', null)
					// $(this).prepend('<div class="featured-image__bg" aria-hidden="true">'+$imageClone+'</div>');
					$(this).prepend($imageWrapper.prepend($imageClone))
				}
			});
		}

    return {
        init: init,
    };
})();
